<span *ngIf="price >=0" class="{{styleClass}}">{{ price | currencyConversion }}</span>